import { ReplyRequestDto } from '../../dtos/reply-request.dto';
import { ReplyDto } from '../../dtos/reply.dto';
import { ReviewFiltersDto } from '../../dtos/review-filters.dto';
import { ReviewStatisticsBreakdownDto } from '../../dtos/review-statistics-breakdown.dto';
import { ReviewStatisticsOverTimeBreakdownDto } from '../../dtos/review-statistics-over-time-breakdown.dto';
import { ReviewStatisticsDto } from '../../dtos/review-statistics.dto';
import { ReviewDto } from '../../dtos/review.dto';
import { ReplyRequestModel } from '../../models/reply-request.model';
import { ReplyModel } from '../../models/reply.model';
import { ReviewStatisticsBreakdownModel } from '../../models/review-statistics-breakdown.model';
import { ReviewStatisticsOverTimeBreakdownModel } from '../../models/review-statistics-over-time-breakdown.model';
import { ReviewStatisticsModel } from '../../models/review-statistics.model';
import { ReviewModel } from '../../models/review.model';
import { ReviewFiltersModel } from '../../thunks/models/review-filters.model';

export const mapReplyDtoToReplyModel = (reply: ReplyDto): ReplyModel => ({
  reply: reply.reply,
  creationDate: reply.creationDate,
  id: reply.id,
  updateDate: reply.updateDate,
  replierName: reply.replierName,
  reviewId: reply.reviewId,
});

export const mapReplyRequestDtoToReplyRequestModel = (
  reply: ReplyRequestDto
): ReplyRequestModel => ({
  reply: reply.reply,
  reviewId: reply.reviewId,
});

export const mapReviewDtoToReviewModel = (review: ReviewDto): ReviewModel => ({
  id: review.id,
  review: review.review,
  appId: review.appId,
  creationDate: review.creationDate,
  mandantId: review.mandantId,
  platform: review.platform,
  rating: review.rating,
  release: review.release,
  releaseId: review.releaseId,
  author: review.author,
  vehicle: review.vehicle,
  reply: review.reply ? mapReplyDtoToReplyModel(review.reply) : null,
});

export const mapReviewStatisticsOverTimeBreakdownDtoToReviewStatisticsOverTimeBreakdownModel =
  ({
    totalNrOfRatings,
    momentInTime,
    totalRating,
  }: ReviewStatisticsOverTimeBreakdownDto): ReviewStatisticsOverTimeBreakdownModel => ({
    totalNrOfRatings,
    momentInTime,
    totalRating,
  });

export const mapReviewStatisticsBreakdownDtoToReviewStatisticsBreakdownModel =
  ({
    totalNrOfRatings,
    rating,
  }: ReviewStatisticsBreakdownDto): ReviewStatisticsBreakdownModel => ({
    totalNrOfRatings,
    rating,
  });

export const mapReviewStatisticsDtoToReviewStatisticsModel = ({
  totalReviews,
  totalRatings,
  overtimeBreakDown,
  overAllRating,
  ratingBreakdown,
}: ReviewStatisticsDto): ReviewStatisticsModel => ({
  overAllRating,
  totalReviews,
  totalRatings,
  overtimeBreakDown: overtimeBreakDown.map(
    mapReviewStatisticsOverTimeBreakdownDtoToReviewStatisticsOverTimeBreakdownModel
  ),
  ratingBreakdown: ratingBreakdown.map(
    mapReviewStatisticsBreakdownDtoToReviewStatisticsBreakdownModel
  ),
});

export const mapReviewsFiltersDtoToReviewsFiltersModel = ({
  releases,
  vehicles,
  platforms,
}: ReviewFiltersDto): ReviewFiltersModel => ({
  platforms,
  releases,
  vehicles,
});
